import { TEMPLATE_PARTS } from '../../lib/u99';
import PaperBody from './PaperBody';
import { Label } from '../u99/Label';

export const templateTocItems = (doc) =>
  TEMPLATE_PARTS.filter((p) => (p.key === 'open_questions' ? doc.open_questions?.length : doc[p.key])).map((p) => ({ level: 2, text: `${p.n} · ${p.title}`, id: `t-${p.key}` }));

export default function TemplateSections({ doc }) {
  return (
    <div className="space-y-16" data-testid="template-sections">
      {TEMPLATE_PARTS.map((p) => {
        const value = doc[p.key];
        if (p.key === 'open_questions' ? !value?.length : !value) return null;
        return (
          <section key={p.key} id={`t-${p.key}`} className="scroll-mt-28" data-testid={`template-${p.key}`}>
            <div className="flex items-baseline gap-4 mb-6">
              <span className="font-celestial text-amber-300/80 text-lg">{p.n}</span>
              <h2 className="font-celestial text-2xl sm:text-3xl text-slate-100 leading-snug">{p.title}</h2>
            </div>
            {p.key === 'core_statement' ? (
              <p className="font-celestial text-xl sm:text-2xl lg:text-3xl leading-relaxed text-amber-50/90 border-l border-amber-400/60 pl-6">{value}</p>
            ) : p.key === 'open_questions' ? (
              <ol className="space-y-4">
                {value.map((q, i) => (
                  <li key={`${i}-${q.slice(0, 24)}`} className="flex gap-5 text-[17px] sm:text-lg leading-relaxed text-slate-300/90">
                    <span className="font-celestial text-slate-600 shrink-0">{String(i + 1).padStart(2, '0')}</span>
                    <span>{q}</span>
                  </li>
                ))}
              </ol>
            ) : (
              <>
                {p.key === 'evidence_status' && <div className="mb-5"><Label id={doc.label} /></div>}
                <PaperBody markdown={value} />
              </>
            )}
          </section>
        );
      })}
    </div>
  );
}
